<div class="form__block">
  <div class="heading heading_standard heading_centered">
    Payment information
  </div>
  <div class="cart-form__desc">This card will be saved in your account</div>
  <div class="fields">
    <div
      class="fields__item fields__item_icon fields__item_full"
      [appIfInvalid]="cardNumberFC"
      [validationErrors]="{
        required: 'Please, enter card number',
      }"
    >
      @if (isBrowser) {
        <input
          [formControl]="cardNumberFC"
          type="text"
          placeholder=""
          maxlength="50"
          autocomplete="cc-number"
          id="card_number"
          [imask]="cardNumberMask"
        />
      } @else {
        <input
          [formControl]="cardNumberFC"
          type="text"
          placeholder=""
          maxlength="50"
          autocomplete="cc-number"
          id="card_number"
        />
      }
      <label for="card_number">Card number</label>
      <img
        src="assets/icon-card.svg"
        width="58"
        height="39"
        alt="Credit Card"
      />
      <ng-template [appErrorsHost] />
    </div>

    <div
      class="fields__item fields__item_half"
      [appIfInvalid]="expirationDateFC"
      [validationErrors]="{
        required: 'Please, enter card expiration date',
      }"
    >
      @if (isBrowser) {
        <input
          [formControl]="expirationDateFC"
          type="text"
          placeholder=""
          maxlength="5"
          autocomplete="cc-exp"
          id="expiration_date"
          [imask]="expirationDateMask"
        />
      } @else {
        <input
          [formControl]="expirationDateFC"
          type="text"
          placeholder=""
          maxlength="5"
          autocomplete="cc-exp"
          id="expiration_date"
        />
      }
      <label for="expiration_date">MM/YY</label>
      <ng-template [appErrorsHost] />
    </div>

    <div
      class="fields__item fields__item_half"
      [appIfInvalid]="cvcFC"
      [validationErrors]="{
        required: 'Please, enter cvc',
      }"
    >
      @if (isBrowser) {
        <input
          [formControl]="cvcFC"
          type="text"
          placeholder=""
          maxlength="5"
          autocomplete="cc-exp"
          id="cvc"
          [imask]="cvcMask"
        />
      } @else {
        <input
          [formControl]="cvcFC"
          type="text"
          placeholder=""
          maxlength="5"
          autocomplete="cc-exp"
          id="cvc"
        />
      }
      <label for="cvc">CVC</label>
      <ng-template [appErrorsHost] />
    </div>
  </div>
</div>
